/**
 * 同一ページ内アンカーリンクのスムーススクロール
 * jQuery は BaseLayout で読み込み済みの前提
 */
export function init() {
	if (typeof window.$ === 'undefined') return;
	const $ = window.$;
	$(window).on('load', function () {
		$('a[href*="#"], area[href*="#"]').on('click', function () {
			const speed = 500;
			const href = $(this).attr('href');
			const target = $(href === '#' || href === '' ? 'html' : href);
			if (window.matchMedia('(min-width:768px)').matches) {
				const positionPc = target.offset().top - 104;
				$('html, body').animate({ scrollTop: positionPc }, speed, 'swing');
			} else {
				const positionSp = target.offset().top - 60;
				$('html, body').animate({ scrollTop: positionSp }, speed, 'swing');
			}
			return false;
		});
	});
}
